// extracted by mini-css-extract-plugin
export default {"root":"DataSourceHeader_root__JThkf","chips":"DataSourceHeader_chips__BYwBj"};